import { CSSProperties, ReactNode, useState } from "react";
import { Col, Row } from "antd";
import { ContainerArrow } from "src/components/ContainerArrow";

export const CollapsibleRow = (props: {
  preview: ReactNode;
  content: ReactNode;
  style?: CSSProperties;
  arrowStyle?: CSSProperties;
  className?: string;
  arrowSize?: number;
  expand?: boolean;
  openOnPreviewClick?: boolean;
  disabled?: boolean;
}) => {
  const [opened, setOpened] = useState(props.expand === true);
  const [_, setNoop] = useState(false);
  return (
    <div style={props.style} className={props.className}>
      <Row style={props.arrowStyle}>
        <ContainerArrow
          mobile
          opened={opened}
          setOpened={props.disabled ? setNoop : setOpened}
          size={props.arrowSize || 30}
        />
        <Col
          flex={"auto"}
          style={{ width: `calc(100% - ${props.arrowSize || 30}px)` }}
          onClick={() => {
            if (props.disabled) return;
            if (!props.openOnPreviewClick) return;
            setOpened((t) => !t);
          }}
        >
          {props.preview}
        </Col>
      </Row>
      {opened && (
        <Row>
          <Col span={24}>{props.content}</Col>
        </Row>
      )}
    </div>
  );
};
